// src/pages/product-module/UpdateProduct.js
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudForm from "../../components/dashboard/form/CrudForm";
import productService from "../../services/productService";
import { BASE_IMAGE_URL } from "../../services/apiService";

export default function UpdateProduct() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [brands, setBrands] = useState([]);
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const localCacheKey = `productEditCache_${id}`;
  const allowedFields = [
    "name",
    // "thumb_image",
    "images",
    "category_id",
    "sub_category_id",
    "child_category_id",
      // "brand_id",  
    "qty",
    "short_description",
    "long_description",
    "video_link",
    "sku",
    "price",
    "offer_price",
    "offer_start_date",
    "offer_end_date",
    "product_type",
    "status",
      // "is_prescription", 
    "seo_title",
    "seo_description",
    "is_approved",
    "colors"

  ];
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  // -----------------------------
  // Load product data + dropdowns
  // -----------------------------
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        // Fetch product and dropdowns in parallel
        const [productRes, catRes, subCatRes, childCatRes ,  brandRes] = await Promise.all([
          productService.getProductById(id),
          productService.getAllCategories(),
          productService.getAllSubCategories(),
          productService.getAllChildCategories(),
            productService.getAllBrands(),
        ]);
        const isActive = (item) => item.status === true || item.status === 1;

let brandsData = brandRes.data?.data || brandRes.data || [];
brandsData = brandsData.filter(isActive);

setBrands(brandsData);
        const product = productRes.data?.data || productRes.data;
        console.log(product, "products")
        // Normalize product data for form
       const normalized = allowedFields.reduce((acc, field) => {
  if (field === "status" || field === "is_prescription" || field === "is_approved") {
    acc[field] = product[field] ?? 1;
  } else {
    acc[field] = product[field] ?? "";
  }
  return acc;
}, {});
        normalized.colors = product.colors
  ? product.colors.map(c => c.color_code)
  : [];
     const galleryImages = product.product_image_galleries
  ? product.product_image_galleries.map((img) => ({
      id: img.id,
      image: img.image,
      type: "gallery"
    }))
  : [];

const thumb = product.thumb_image
  ? [{
      image: product.thumb_image,
      type: "thumb"
    }]
  : [];

normalized.images = [...thumb, ...galleryImages];
        setInitialData(normalized);
        setCategories(catRes.data?.data || catRes.data);
        setSubCategories(subCatRes.data?.data || subCatRes.data);
        setChildCategories(childCatRes.data?.data || childCatRes.data);
        // Cache locally
        localStorage.setItem(localCacheKey, JSON.stringify(normalized));
      } catch (error) {
        console.error("Failed to load product:", error);
        Swal.fire("Error", "Failed to load product details.", "error");
        navigate("/admin/all-products");
      } finally {
        setLoading(false);
      }
    };
    const cached = localStorage.getItem(localCacheKey);
    if (cached) {
      setInitialData(JSON.parse(cached));
      setLoading(false);
    }
    loadData();
  }, [id, navigate, localCacheKey]);    
  // -----------------------------   
  // Handle submit 
  // -----------------------------
  const handleSubmit = useCallback(async (formData) => {
    console.log("FORM DATA BEFORE SUBMIT:", formData);
console.log("IMAGES ARRAY:", formData.images);
    try {
      const slug = formData.name
        ?.toLowerCase()
        .trim()
        .replace(/\s+/g, "-") || "";

      const payload = {
        ...formData,
        slug,
        status: Number(formData.status ?? 1),
          is_prescription: Number(formData.is_prescription ?? 1),
        is_approved: Number(formData.is_approved ?? 0),
      };

      delete payload.images; 

      const form = new FormData();

      // Append all fields
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          form.append(key, value.toString());
        } else if (key === "name") {
          form.append("name", "");
        }
      });

      form.append("_method", "PUT");


      // Append images
    const imagesArray = Array.isArray(formData.images) ? formData.images : [];

imagesArray.forEach((img) => {

  // 🆕 NEW IMAGE
  if (img instanceof File) {
    form.append("images[]", img);
  }

  //  OLD IMAGE
  else if (typeof img === "string") {
    form.append("existing_images[]", img);
  }

});  

const colorsArray = Array.isArray(formData.colors)
  ? formData.colors
  : [];

colorsArray.forEach((color) => {
  form.append("colors[]", color);
});
      console.log("FormData entries:");
      console.log("Images array:", formData.images);
      for (let pair of form.entries()) {
        console.log(pair[0], pair[1]);
      }
      // await productService.updateProductWithFile(id, form);
      const res = await productService.updateProductWithFile(id, form);

console.log("UPDATE RESPONSE:", res);

    Swal.fire({
  title: "Success",
  text: "Product updated successfully!",
  icon: "success",
  showConfirmButton: true,
  confirmButtonText: "OK",
    confirmButtonColor: "#124c54",
  customClass: {
    confirmButton: "swal-confirm-btn"
  },
  didOpen: () => {
    // Inject style dynamically if it doesn't exist
    if (!document.getElementById("swal-button-style")) {
      const style = document.createElement("style");
      style.id = "swal-button-style";
      style.innerHTML = `
        .swal-confirm-btn {
          background-color: var(--color-text-green) !important;
          color: #fff !important;
          border: none !important;
          border-radius: 4px !important;
          padding: 8px 20px !important;
          font-weight: bold !important;
        }
      `;
      document.head.appendChild(style);
    }
  }
});
      navigate("/admin/all-products");
    } catch (error) {
      console.error(error.response?.data || error);
      const errors = error.response?.data?.errors || {};
      const firstError = Object.values(errors)[0]?.[0] || "Update failed";
      Swal.fire("Error", firstError, "error");
    }
  }, [id, navigate]);
  // -----------------------------
  // Render
  // -----------------------------
  if (loading) {
    return (
      <DashboardWrapper>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "300px" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </DashboardWrapper>
    );
  }
  if (!initialData) {
    return (
      <DashboardWrapper>
        <div className="alert alert-danger">Product data not found.</div>
      </DashboardWrapper>
    );
  }
  return (
    <DashboardWrapper>
      <div className="p-4">
        <h1 className="h4 mb-4">Update Product </h1>
        <div className="card">
          <h5 className="card-header">Edit Product</h5>
          <div className="card-body">
            <CrudForm
              initialData={initialData}
              onSubmit={handleSubmit}
              allowedFields={allowedFields}
              fileUploadStyle="product"
              fileFields={[{ name: "images", multiple: true },
                  // { name: "thumb_image", multiple: false }, 
              ]} 
              
              categories={categories}
              subCategories={subCategories}
              childCategories={childCategories}
                brands={brands} 
            />
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}